import { render, staticRenderFns } from "./GameState.vue?vue&type=template&id=3ef62d64&"
import script from "./GameState.vue?vue&type=script&lang=js&"
export * from "./GameState.vue?vue&type=script&lang=js&"
import style0 from "./GameState.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports